<template>
  <div>
    <files-selected @save-image="addImage" :Data="imagePosition"  :is-modal-files-selected-show.sync="isModalFilesSelectedShow"  />
    <block-form 
      @save-block="addBlocks" 
      :contentData="blockPosition"
      :is-modal-blocks-selected-show.sync="isModalBlocksSelectedShow"  
    />
    <table-form 
      @save-table="addTable" 
      :contentData.sync="tablePosition"
      :is-modal-table-selected-show.sync="isModalTableSelectedShow"  
    />
    
    <br/>
    <div  v-if="!loading_data">
      <draggable 
        v-model="sections" 
        @change="ChangeOrdering(sections)"
        handle=".handle"
      >
        <b-card   v-for="(item, index) in sections" :key="'repeat-'+index"  >
          <b-row>
            <b-col
              cols="12"
              md="1"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <MenuIcon icon="MenuIcon" class="handle"/>
            </b-col>
            <b-col
              cols="12"
              md="3"
              sm="9"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <h2> Section {{ index + 1 }} </h2>
            </b-col>
            <b-col
              cols="12"
              md="4"
              offset-md="3"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  @click="removeItem(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span> Delete </span>
                </b-button>
              </div>
            </b-col>
            <b-col
              cols="12"
              md="1"
              offset-md="0"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="mr-2"
                  :class="isOpen ? null : 'collapsed'"
                  :aria-expanded="isOpen ? 'true' : 'false'"
                  aria-controls="'collapse-' + index"
                  @click="toggleVisibility(index)"
                >
                  {{ visibleSections[index] ? 'Hide' : 'Show' }}
                </b-button>
              </div>
            </b-col>
          </b-row>
          <br/>
          <b-collapse id="'collapse-' + index" v-model="visibleSections[index]" class="mt-2">
            <b-card>
              <div >
                <div ref="el">
                  <div v-for="item in list" :key="item.id">
                    {{ item.name }}
                  </div>
                </div>
                <b-row
                  :id="item.id"
                  :key="'content-'+index"
                  ref="row"
                  v-if="item.remove !== true"
                >
                  <b-col md="12">
                    <b-form-group label="Type Component" label-for="group_id">
                      <v-select
                        class="d-block"
                        v-model="item.group_id"
                        placeholder="Select Type Component"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :reduce="(option) => option.id"
                        :options="groupsData"
                        @input="changeType($event,index)"
                      />
                    </b-form-group>
                    <b-form-group label="Component" label-for="component_id">
                      <v-select
                        class="d-block"
                        v-model="item.component_id"
                        placeholder="Select Component"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :reduce="(option) => option.id"
                        :options="components[index]"
                        @input="changeComponent($event,index)"
                      />
                    </b-form-group>
                    <form-component 

                    v-if="item.data.length > 0 && !loading_form"
                      v-for="(dat,key) in item.data" 
                      :key="'data-'+index+'-'+key" 
                      :data.sync="dat" 
                      :dataKey="key" 
                      :dataBanners="dataBanners" 
                      :commentData="commentData"
                      :dataIndex="index"
                      @update-block="UpdateBlock"
                       
                      @open-files="OpenFiles"  
                      @open-blocks="OpenBlocks"  
                      @open-table="OpenTable"
                      @refetch-data="changeDataComponent" 
                      @ordering-blocks="orderingBlocks"
                      @ordering-tables="orderingTables"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-collapse>
        </b-card>
      </draggable>
      
      <b-row>
        <b-col md="12" class="text-right"> 
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-success"
            @click="repeateAgain"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-25"
            />
            <span>Add New Section</span>
          </b-button>
        </b-col>
        <b-col md="2"></b-col>
      </b-row>
    </div>
  </div>
</template>
  
<script>
  import BCardCode from '@core/components/b-card-code'
  import {
    BCard, BCardText, BFormFile, BForm, BFormGroup, BFormInput, BFormTextarea, BRow, BCol, BButton, BImg, BCollapse,
  } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import { heightTransition } from '@core/mixins/ui/transition'
  import Ripple from 'vue-ripple-directive'
  import { ref, onUnmounted } from '@vue/composition-api'
  import draggable from 'vuedraggable'
  import {  MenuIcon } from 'vue-feather-icons'
  import 'quill/dist/quill.core.css'
  // eslint-disable-next-line
  import 'quill/dist/quill.snow.css'
  // eslint-disable-next-line
  import 'quill/dist/quill.bubble.css'
  //import { slugify } from '@/@fake-db/utils'
  import { quillEditor } from 'vue-quill-editor'
  import groupStoremodule from '@/views/components/groupStoremodule'
  import store from '@/store'
  import FormComponent from './FormComponent.vue'
  import bannerStoreModule from '@/views/banner/bannerStoreModule'
  import FilesSelected from './FilesSelected.vue'
  import BlockForm from './BlockForm.vue'
  import TableForm from './TableForm.vue'
  import { reactive } from 'vue'
  import commentStoreModule from '@/views/comment/commentStoreModule'

  export default {
    components: {
      BCard, BCardText, BFormFile, BCardCode, BForm, BRow, BCol, BButton, BFormGroup, BFormInput, BImg,
      BFormTextarea, FormComponent, vSelect, quillEditor, FilesSelected, draggable, MenuIcon, BlockForm, 
      BCollapse,TableForm
    },
    
    directives: {
      Ripple,
    },

    model: {
      prop: 'PageInputRepeater',
      prop: 'PageInputRepeaterRemove',
      event: 'update:page-input-repeater',
      event: 'update::page-input-repeater-remove'
    },

    props: {
      PageInputRepeater: {
        type: Array,
        required: true,
      },
      PageInputRepeaterRemove: {
        type: Array,
        required: true,
      },
      pageData: {
        type: Object,
        required: false,
      },
      dataKey:{
        type: Number,
      },
      dataIndex:{
        type: Number
      },
    },

    mixins: [ heightTransition ],

    mounted() {
      //this.initTrHeight()
    },

    created() {
     // window.addEventListener('resize', this.initTrHeight)
    },

    destroyed() {
     // window.removeEventListener('resize', this.initTrHeight)
    },

    watch:{
      isModalFilesSelectedShow:function(val) {
        this.getPopupStatus(val);
      },
    },

    setup(props, { emit }) {
      const loading_form = ref(false);
      const loading_data = ref(false);

      const GRUOP_STORE_MODULE_NAME = 'app-components-group';
      if (!store.hasModule(GRUOP_STORE_MODULE_NAME)) store.registerModule(GRUOP_STORE_MODULE_NAME, groupStoremodule)
      onUnmounted(() => {
          if (store.hasModule(GRUOP_STORE_MODULE_NAME)) store.unregisterModule(GRUOP_STORE_MODULE_NAME)
      });
  
      const BANNER_STORE_MODULE_NAME = 'app-banner';
      if (!store.hasModule(BANNER_STORE_MODULE_NAME)) store.registerModule(BANNER_STORE_MODULE_NAME, bannerStoreModule)
      onUnmounted(() => {
          if (store.hasModule(BANNER_STORE_MODULE_NAME)) store.unregisterModule(BANNER_STORE_MODULE_NAME)
      });

      const COMMENT_STORE_MODULE_NAME = 'app-comment';
      if (!store.hasModule(COMMENT_STORE_MODULE_NAME)) store.registerModule(COMMENT_STORE_MODULE_NAME, commentStoreModule)
      onUnmounted(() => {
          if (store.hasModule(COMMENT_STORE_MODULE_NAME)) store.unregisterModule(COMMENT_STORE_MODULE_NAME)
      });

      const isModalFilesSelectedShow = ref(false);
      const isModalBlocksSelectedShow = ref(false);
      const isModalTableSelectedShow = ref(false);
      const Layouts = ref([
        {
          id:1,
          title:'Layout 1'
        },
        {
          id:2,
          title:'Layout 2'
        },
        {
          id:3,
          title:'Layout 3'
        },
      ]);
      const groupsData = ref([]);
      const dataBanners = ref([]);
      const gcData = ref([]);
      const imagePosition = ref({});
      const blockPosition = ref({});
      const sections =  ref([]);
      let components = [];
      const getLocalSite = JSON.parse(localStorage.getItem('site'))
      const visibleSections = ref({});
      const isOpen = ref({});
      const commentData = ref([])


      const tablePosition = ref({});

      const orderingBlocks = (items, positiondata, positionComponent) => {
        props.PageInputRepeater[positionComponent].data[positiondata].blocks = items
      }
      const orderingTables = (items, positiondata, positionComponent) => {
        loading_form.value = true;
        props.PageInputRepeater[positionComponent].data[positiondata].tables = items
        setTimeout(function() { loading_form.value = false; }, 100);

      }

      const getData = () => {
        sections.value = props.PageInputRepeater
        sections.value.forEach((_, index) => {
          visibleSections.value[index] = true;
          isOpen.value = visibleSections.value[index]
        });
      }

      getData()

      const getGroups = async()=>{
        const groups =  await store.dispatch('app-components-group/fetchData')
        groupsData.value = groups.data.data

        if(props.PageInputRepeater.length > 0){
          props.PageInputRepeater.map((value,index)=>{
            getType(value.group_id, index);
          });
        }
      }

      const updateComponentsOrdering  = async ()=>{
        await store.dispatch('app-pages/updateComponentsGroupsOrdering',groupsData.value)
        fetchData();
      }
     
      const nextTodoId = ref(props.PageInputRepeater.length+1);

      

      const repeateAgain = ()=>{
        props.PageInputRepeater.push({
          component:'',
          image:null,
          title:null,
          description:null,
          show:false,
          data:[]
        });

        sections.value = props.PageInputRepeater
        visibleSections.value[sections.value.length-1] = true;
        isOpen.value = true
      }

      const toggleVisibility = (index) =>  {
        isOpen.value = {}

        if(visibleSections.value[index]){
          visibleSections.value[index] = false
        } else {
          visibleSections.value[index] = true
        }
        
        isOpen.value = visibleSections.value[index]
      }

      const revomeImage = (key)=>{
        props.PageInputRepeater[key].image = '';
      }

      const removeItem = (index)=>{
        if( props.PageInputRepeater[index].id > 0){
          props.PageInputRepeaterRemove.push(props.PageInputRepeater[index].id);
        }

        props.PageInputRepeater.splice(index,1);
      }

      const getType = (event,key)=>{
        let index = groupsData.value.findIndex(val => val.id===event)
        components[key]  = groupsData.value[index].components;
      }
      
      const changeType = (event,key)=>{
        let index = groupsData.value.findIndex(val => val.id===event)
        components[key]  = groupsData.value[index].components;

        props.PageInputRepeater[key].data = [];
        props.PageInputRepeater[key].component_id = '';
      }
      
      const changeComponent = (event,key)=>{
        let index = components[key].findIndex(val => val.id===event)
        let data = components[key][index].data.map((v,i)=>{
          if(v.type == 'blocks'){
            v.blocks = [];
          }
          if(v.type == 'table'){
            v.tables = [];
          }
          
          
          v.value = '';
          return v;
        });

        props.PageInputRepeater[key].component =  components[key][index].component;
        props.PageInputRepeater[key].data  = data;
      }

      const changeDataComponent = (data)=>{
        props.PageInputRepeater[data.index].data[data.key] = data;
      }
      
      const getBanners = async()=>{
        const banners = await store.dispatch('app-banner/fetchData',{
            sites_id: getLocalSite.id,
        });
        dataBanners.value = banners.data.data
      }

      const getComments = async () => {
        const comments = await store.dispatch('app-comment/fetchData',{
            sites_id: getLocalSite.id,
        });

        commentData.value = comments.data.data
      }

      getGroups();

      getBanners();

      getComments();

      const OpenFiles = (position)=>{
        imagePosition.value = position;
        isModalFilesSelectedShow.value = true;
      }

      const OpenBlocks = (position)=>{
        blockPosition.value = position;
        isModalBlocksSelectedShow.value = true;
      }

      const UpdateBlock = (data) => {
        // console.log('update block data section', data)
        // sections.value.data
        // console.log('check after set section', sections.value)
        // emit('onChangeOrdering', data);
      }
      
      const getPopupStatus = (status)=>{
        loading_data.value = status;
      }
      
      const addImage = (files)=>{
        props.PageInputRepeater[imagePosition.value.dataIndex].data[imagePosition.value.dataKey].files = files;
        isModalFilesSelectedShow.value = false;
      }

      const addBlocks = (blocks)=>{
        loading_form.value = true;

        if(blocks.blockIndex >=0){
          props.PageInputRepeater[blockPosition.value.dataIndex].data[blockPosition.value.dataKey].blocks[blockPosition.value.blockIndex] = blocks;
        } else {
          props.PageInputRepeater[blockPosition.value.dataIndex].data[blockPosition.value.dataKey].blocks.push(blocks);
        }

        setTimeout(function() { loading_form.value = false; }, 100);
        isModalBlocksSelectedShow.value = false
        
        emit('onSubmit')
      }
      const addTable = (tables)=>{
        loading_form.value = true;
        
        if(props.PageInputRepeater[tablePosition.value.dataIndex].data[tablePosition.value.dataKey].tables[tablePosition.value.tableIndex]){
        
          props.PageInputRepeater[tablePosition.value.dataIndex].data[tablePosition.value.dataKey].tables[tablePosition.value.tableIndex] = tables;
        } else {
          props.PageInputRepeater[tablePosition.value.dataIndex].data[tablePosition.value.dataKey].tables.push(tables);
        }

        setTimeout(function() { loading_form.value = false; }, 100);
       // isModalBlocksSelectedShow.value = false

        emit('onSubmit')

      }

      const ChangeOrdering  = (items)=>{
        emit('onChangeOrdering', items);
      }
      const OpenTable = (position)=>{
      
        tablePosition.value = position;
        isModalTableSelectedShow.value = true;

      }

      return {
        list: [],
        repeateAgain,
        nextTodoId,
        Layouts,
        removeItem,
        revomeImage,
        groupsData,
        components,
        changeType,
        changeComponent,
        changeDataComponent,
        dataBanners,
        OpenFiles,
        isModalFilesSelectedShow,
        isModalBlocksSelectedShow,
        isModalTableSelectedShow,
        imagePosition,
        blockPosition,
        addImage,
        loading_data,
        getPopupStatus,
        updateComponentsOrdering,
        groupsData,
        ChangeOrdering,
        sections,
        addBlocks,
        OpenBlocks,
        loading_form,
        UpdateBlock,
        orderingBlocks,
        orderingTables,
        visibleSections,
        toggleVisibility,
        isOpen,
        OpenTable,
        addTable,
        tablePosition,
        commentData,
        getComments,
      }
    },

    methods: {
      
    },
  }
</script>
  
<style lang="scss" scoped>
  .repeater-form {
    overflow: hidden;
    transition: .35s height;
  }
</style>
  